var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1C20.6569 1 22 2.34315 22 4V20C22 21.6569 20.6569 23 19 23H6C4.34315 23 3 21.6569 3 20V4C3 2.34315 4.34315 1 6 1H19ZM7 3H6C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21H19C19.5523 21 20 20.5523 20 20V4C20 3.44772 19.5523 3 19 3H18V4C18 4.51284 17.614 4.93551 17.1166 4.99327L17 5C16.4872 5 16.0645 4.61396 16.0067 4.11662L16 4V3H15V4C15 4.51284 14.614 4.93551 14.1166 4.99327L14 5C13.4872 5 13.0645 4.61396 13.0067 4.11662L13 4V3H12V4C12 4.51284 11.614 4.93551 11.1166 4.99327L11 5C10.4872 5 10.0645 4.61396 10.0067 4.11662L10 4V3H9V4C9 4.51284 8.61396 4.93551 8.11662 4.99327L8 5C7.48716 5 7.06449 4.61396 7.00673 4.11662L7 4V3ZM12.5 16C13.0523 16 13.5 16.4477 13.5 17C13.5 17.5523 13.0523 18 12.5 18H9C8.44772 18 8 17.5523 8 17C8 16.4477 8.44772 16 9 16H12.5ZM9 12H16C16.5523 12 17 12.4477 17 13C17 13.5128 16.614 13.9355 16.1166 13.9933L16 14H9C8.44772 14 8 13.5523 8 13C8 12.4872 8.38604 12.0645 8.88338 12.0067L9 12H16H9ZM16 8C16.5523 8 17 8.44772 17 9C17 9.51284 16.614 9.93551 16.1166 9.99327L16 10H9C8.44772 10 8 9.55229 8 9C8 8.48716 8.38604 8.06449 8.88338 8.00673L9 8H16Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconNote.01f0b216f1ffc9fb1059e218a8683ce5.svg";